import React from 'react';
import { Outlet } from 'react-router';
import Sidebar from '../Sidebar';

export default function WithSideBar() {
     return (
          <div>
               <Sidebar />
               <Outlet />
          </div>
     );
}
